import { render, staticRenderFns } from "./VodafoneRepairHome.vue?vue&type=template&id=5b774d6e"
import script from "./VodafoneRepairHome.vue?vue&type=script&lang=js"
export * from "./VodafoneRepairHome.vue?vue&type=script&lang=js"
import style0 from "./VodafoneRepairHome.vue?vue&type=style&index=0&id=5b774d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports